import {
	InnovyzeRole,
	RegisteredApplications,
	mapRole,
} from '@innovyze/stylovyze';
import { UpdateRoleParams, UserParams } from '@Types/users.types';
import { User, UserAction } from '@Types/user.types';

import admin from '@Apis/admin.api';

export const createUser = (
	userData: User,
	applicationName?: RegisteredApplications,
) => {
	return admin.post('/user', {
		firstName: userData.name,
		role: userData.role,
		email: userData.email,
		phoneNumber: userData.phoneNumber,
		entitlements: userData.entitlements,
		applicationName,
	});
};

export const getUsers = (params: UserParams) => admin.get('/users', { params });
export const getSingleUserService = (auth0Id: string) =>
	admin.get(`/user/${encodeURI(auth0Id)}`);

export const deleteUser = (userId: string) =>
	admin.delete(encodeURI(`/user/${userId}`));

export const setEntitlements = (userId: string, body: string[]) =>
	admin.put(encodeURI(`/user/${userId}`), {
		admin: body,
	});

export const changeRole = (params: UpdateRoleParams) =>
	admin.put(encodeURI(`/user/${params.userId}`), {
		role: params.role,
	});

export const updateUser = (params: User) =>
	admin.put(encodeURI(`/user/${params.id}`), {
		role: mapRole(params.role as InnovyzeRole),
		entitlements: params.entitlements,
		name: params.name,
		phoneNumber: params.phoneNumber,
	});

export const bulkUserOperationsService = (userOperations: UserAction[]) => {
	return admin.post(encodeURI('/users/bulk'), { operations: userOperations });
};
